import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { ForbiddenState } from './components/StatePanels'
import { PreviewRibbon, SecondaryShell } from './components/Shell'
import { canAccess } from './router/access'
import { useSession } from './session/SessionProvider'
import {
  BadgeDetailPage,
  BadgesPage,
  GardenPage,
  GrowthPage,
  HomePage,
  ThanksActivityPage,
  ThanksPage,
  TrainingDetailPage,
  TrainingExamPage,
  TrainingResultsPage,
  TrainingTeachingPage,
} from './pages/PrimaryPages'
import {
  AccountPage,
  BroadcastDetailPage,
  DocumentsPage,
  FunctionsPage,
  KnowledgePage,
  LoginPage,
  ManagerPage,
  NotificationsPage,
  PromotionPage,
} from './pages/SecondaryPages'

function RequireAuth() {
  const { user } = useSession()
  return user ? <Outlet /> : <Navigate to="/login" replace />
}

function RequireManager() {
  const { user } = useSession()
  if (!user) return <Navigate to="/login" replace />
  if (!canAccess('manager', user.role)) return <SecondaryShell title="權限限制" backTo="/functions"><ForbiddenState /></SecondaryShell>
  return <Outlet />
}

function RootRedirect() {
  const { user } = useSession()
  return <Navigate to={user ? '/home' : '/login'} replace />
}

function NotFound() {
  return <SecondaryShell title="找不到頁面" backTo="/home"><section className="state-panel"><h2>這個入口不存在</h2><p>請回到首頁重新選擇功能。</p></section></SecondaryShell>
}

export default function App() {
  return (
    <>
      <PreviewRibbon />
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/home" element={<HomePage />} />
          <Route path="/growth" element={<GrowthPage />} />
          <Route path="/training/:moduleId" element={<TrainingDetailPage />} />
          <Route path="/training/:moduleId/exam" element={<TrainingExamPage />} />
          <Route path="/training/:moduleId/teaching" element={<TrainingTeachingPage />} />
          <Route path="/training/:moduleId/results" element={<TrainingResultsPage />} />
          <Route path="/garden" element={<GardenPage />} />
          <Route path="/thanks" element={<ThanksPage />} />
          <Route path="/thanks/activity" element={<ThanksActivityPage />} />
          <Route path="/badges" element={<BadgesPage />} />
          <Route path="/badges/:badgeId" element={<BadgeDetailPage />} />
          <Route path="/functions" element={<FunctionsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/broadcasts/:announcementId" element={<BroadcastDetailPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/knowledge" element={<KnowledgePage />} />
          <Route path="/promotion" element={<PromotionPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route element={<RequireManager />}>
            <Route path="/manager" element={<ManagerPage />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}
